import initialState from "./initialState"
import axios from "axios" 
import { MD5 } from "md5-js-tools"

export const REQUEST_LOGIN = "@@auth/REQUEST_LOGIN"
export const REQUEST_LOGIN_FAILURE = "@@auth/REQUEST_LOGIN_FAILURE"
export const REQUEST_LOGIN_SUCCESS = "@@auth/REQUEST_LOGIN_SUCCESS"
export const REQUEST_LOG_USER_OUT = "@@auth/REQUEST_LOG_USER_OUT"
export const FETCHING_STREAM_FROM_TOKEN = "@@auth/FETCHING_STREAM_FROM_TOKEN"
export const FETCHING_STREAM_FROM_TOKEN_SUCCESS = "@@auth/FETCHING_USER_STREAM_TOKEN_SUCCESS"
export const FETCHING_STREAM_FROM_TOKEN_FAILURE = "@@auth/FETCHING_USER_STREAM_TOKEN_FAILURE"

export default function authReducer(state = initialState.auth, action = {}) {
  switch(action.type) {
    case REQUEST_LOGIN:
      return {
        ...state,
        isLoading: true,
      }
    case REQUEST_LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        user: {},
      }
    case REQUEST_LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        error: null,
        user: {
          success: action.data.success,
          user: action.data.user
        }
      }
    case REQUEST_LOG_USER_OUT:
      return {
        ...initialState.auth,
      }
    case FETCHING_STREAM_FROM_TOKEN:
      return {
        ...state,
        isLoading: true
      }
    case FETCHING_STREAM_FROM_TOKEN_SUCCESS:
      console.log('FETCHING_STREAM_FROM_TOKEN_SUCCESS - Setting isAuthenticated to true');
      return {
        ...state,
        isAuthenticated: true,
        user: {
          ...state.user,
          ...action.data.user,
          streams: action.data.user.streams || [],
          isAdmin: action.data.user.isAdmin !== undefined ? action.data.user.isAdmin : state.user?.isAdmin
        },
        fetchingStreams: false,
        error: null
      }
    case FETCHING_STREAM_FROM_TOKEN_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        userLoaded: true,
        isLoading: false,
        error: action.error,
        user: {}
      }
    default:
      return state
  }
}

export const Actions = {}

Actions.requestUserLogin = ({ email, password }) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_LOGIN })
    const headers = {
      "Content-Type": "application/json",
      'Authorization': 'Basic ' + window.btoa(email + ":" + MD5.generate(password))
    }
    try {
      const res = await axios({
        method: `POST`,
        url: `/api/users/authenticate`,
        data: { email, pass: MD5.generate(password) },
        headers,
      })
      console.log('Login response:', res.data)
      if(res?.data?.success){
        console.log("BasicAuth:" + window.btoa(email + ":" + MD5.generate(password)))
        localStorage.setItem("session", window.btoa(email + ":" + MD5.generate(password)))
        if (res.data.user && res.data.user.isAdmin !== undefined) {
          localStorage.setItem("isAdmin", res.data.user.isAdmin.toString())
        }
        dispatch({ type: REQUEST_LOGIN_SUCCESS, data: res.data })
        return dispatch(Actions.fetchStreamFromToken(window.btoa(email + ":" + MD5.generate(password))))
      } else {
        console.log(res?.data?.message)
        return dispatch({ type: REQUEST_LOGIN_FAILURE, error: res?.data?.message })
      }
    } catch(error) {
      console.log(error)
      return dispatch({ type: REQUEST_LOGIN_FAILURE, error: error?.message })
    }
  }
}

Actions.fetchStreamFromToken = (access_token) => {
  return async (dispatch) => {
    dispatch({ type: FETCHING_STREAM_FROM_TOKEN })
    const token = access_token ? access_token : localStorage.getItem("session")
    const headers = {
      "Content-Type": "application/json",
      'Authorization': 'Basic ' + token
    }
    try {
      const res = await axios({
        method: `GET`,
        url: `/api/streams`,
        headers
      })
      console.log('Stream response:', res.data)
      
      // Get isAdmin from localStorage
      const isAdminFromStorage = localStorage.getItem("isAdmin") === "true"
      
      // Check if we have a valid response with the expected structure
      if (res?.data) {
        // If the response has a user object with streams, use that
        if (res.data.user && Array.isArray(res.data.user.streams)) {
          return dispatch({ 
            type: FETCHING_STREAM_FROM_TOKEN_SUCCESS, 
            data: { 
              user: {
                ...res.data.user,
                isAdmin: res.data.user.isAdmin !== undefined ? res.data.user.isAdmin : isAdminFromStorage
              } 
            } 
          })
        } 
        // If the response is just an array of streams, wrap it in a user object
        else if (Array.isArray(res.data)) {
          return dispatch({ 
            type: FETCHING_STREAM_FROM_TOKEN_SUCCESS, 
            data: { 
              user: { 
                streams: res.data,
                isAdmin: isAdminFromStorage
              } 
            } 
          })
        }
        // If the response has a streams array at the top level
        else if (res.data.streams && Array.isArray(res.data.streams)) {
          return dispatch({ 
            type: FETCHING_STREAM_FROM_TOKEN_SUCCESS, 
            data: { 
              user: { 
                streams: res.data.streams,
                isAdmin: isAdminFromStorage
              } 
            } 
          })
        }
        else {
          console.error('Invalid stream response format:', res.data)
          return dispatch({ 
            type: FETCHING_STREAM_FROM_TOKEN_FAILURE, 
            error: 'Invalid stream data format received from server' 
          })
        }
      } else {
        console.error('Invalid stream response format:', res.data)
        return dispatch({ 
          type: FETCHING_STREAM_FROM_TOKEN_FAILURE, 
          error: 'Invalid stream data format received from server' 
        })
      }
    } catch (error) {
      console.error('Stream fetch error:', error)
      return dispatch({ 
        type: FETCHING_STREAM_FROM_TOKEN_FAILURE, 
        error: error.response?.data?.message || error.message || 'Failed to fetch streams'
      })
    }
  }
}

Actions.logUserOut = () => {
  localStorage.removeItem("session")
  return { type: REQUEST_LOG_USER_OUT }
}